import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import Utility from "../../../shared/utility";
import breadcrumbComp from "../../common/breadcrumb-comp.vue";
export default {
  data: () => ({
    userId: EncryptUtility.localStorageDecrypt("userID"),
    actionList: [],
    favouriteList: [],
    mainPage: "",
    subPage: "",
    backSlash: true,
    backSlashParent: true,
    subPageUrl: "",
    pageUrl: "",
    appPageName: "",
    showAdd: false,
    refresh: true,
    searchStr: "",
    screenList: [],
    menuId: "",
    screenName: "",
    totalRecords: 0,
    addMenuDetailsDialog: false,
    actionName: "",
    rlpSP: "",
    legacySP: "",
    apiURL: "",
    commentsTestCases: "",
    deleteMenuDialog: false,
    deleteRowId: "",
    editMenu: [],
    editMenuDetailsDialog: false,
    editActionName: "",
    editRLPSP: "",
    editLegacySP: "",
    editAPIURL: "",
    editCommentsTestCases: "",
    max200NRRule: [(v) => (v || "").length <= 200 || "Max Length must be 200 characters or less"],
    max200RRule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 200 || "Max Length must be 200 characters or less"],
    screenHeaders: [
      { text: "Action Detail", align: "start", value: "Action Detail", class: "primary customwhite--text", width: "15%" },
      { text: "RLP Web SP", value: "RLP Web SP", class: "primary customwhite--text", width: "20%" },
      { text: "Legacy SP", value: "Legacy SP", class: "primary customwhite--text", width: "20%" },
      { text: "API", value: "API", class: "primary customwhite--text", width: "12%" },
      { text: "Comments", value: "Comments", class: "primary customwhite--text", width: "10%" },
      { text: "Created Date", value: "cdate", class: "primary customwhite--text", width: "15%" },
      { text: "Actions", value: "actions", class: "primary customwhite--text", width: "10%" },
    ],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.mainPage = data?.mainPage;
    this.favouriteList = data?.favouriteList;
    this.pageUrl = data?.pageUrl;
    this.subPage = data?.subPage;
    this.showAdd = data?.showAdd;
    this.subPageUrl = data?.subPageUrl;
    this.appPageName = data?.appPageName;
    let actionData = await AddFavourite.getPageAction(this.userId, this.subPageUrl);
    this.actionList = actionData?.actionList;
    this.menuId = atob(this.$route.params.menuId);
    this.screenName = atob(this.$route.params.screenName);
    if (this.menuId !== undefined && this.menuId !== null && this.menuId !== "") {
      this.getMenuDetails();
    }
  },
  methods: {
    resetFunction() {
      this.searchStr = "";
      this.screenList = [];
      this.totalRecords = 0;
      this.deleteRowId = "";
      this.editMenu = [];
      this.closeDialog();
      this.getMenuDetails();
    },
    //Close Dialog
    closeDialog() {
      if (this.addMenuDetailsDialog) {
        this.actionName = "";
        this.rlpSP = "";
        this.legacySP = "";
        this.apiURL = "";
        this.commentsTestCases = "";
        this.$refs.menuForm.resetValidation();
        this.addMenuDetailsDialog = false;
      }
      if (this.editMenuDetailsDialog) {
        this.editMenu = [];
        this.editActionName = "";
        this.editRLPSP = "";
        this.editLegacySP = "";
        this.editAPIURL = "";
        this.editCommentsTestCases = "";
        this.$refs.editMenuForm.resetValidation();
        this.editMenuDetailsDialog = false;
      }
    },
    //Edit Menu Details
    editMenuDetails(item) {
      this.editMenu = item;
      this.editMenuDetailsDialog = true;
      this.editActionName = item["Action Detail"];
      this.editRLPSP = item["RLP Web SP"];
      this.editLegacySP = item["Legacy SP"];
      this.editAPIURL = item["API"];
      this.editCommentsTestCases = item["Comments"];
    },
    //Get Menu Details
    getMenuDetails() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        user_id: parseInt(this.userId),
        menu_id: parseInt(this.menuId),
      };
      this.axios
        .post("/co/rlp_site_map_details", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            if (response.data.body.message !== null && response.data.body.message !== "") {
              let responsedata = JSON.parse(response.data.body.message);
              let newArr = responsedata.map((obj) => {
                return {
                  ...obj,
                  cdate: Utility.displayDateFormat(obj.cdate),
                };
              });
              this.screenList = newArr;
              this.totalRecords = newArr.length;
            } else {
              this.screenList = [];
              this.totalRecords = 0;
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Delete Menu Detail
    deleteMenuDetails(item) {
      this.deleteRowId = item.row_id;
      this.deleteMenuDialog = true;
    },
    deleteMenu() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("co/rlp_site_map_delete?row_id=" + this.deleteRowId)
        .then((response) => {
          if (response.status == 200) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response?.data?.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.deleteMenuDialog = false;
            this.getMenuDetails();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //New button click
    newClicked() {
      this.actionName = "";
      this.rlpSP = "";
      this.legacySP = "";
      this.apiURL = "";
      this.commentsTestCases = "";
      this.addMenuDetailsDialog = true;
    },
    //Submit Menu Details
    submitMenuDetails() {
      if (this.$refs.menuForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          row_id: 0,
          menu_id: parseInt(this.menuId),
          action_detail: this.actionName,
          rlp_sp: this.rlpSP,
          legacy_rlp_sp: this.legacySP,
          api: this.apiURL,
          comments: this.commentsTestCases,
          user_id: parseInt(this.userId),
        };
        this.axios
          .post("/co/rlp_site_map_upsert", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.closeDialog();
              this.getMenuDetails();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Submit Edit Menu Details
    submitEditMenuDetails() {
      if (this.$refs.editMenuForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          row_id: parseInt(this.editMenu.row_id),
          menu_id: parseInt(this.editMenu.menu_id),
          action_detail: this.editActionName,
          rlp_sp: this.editRLPSP,
          legacy_rlp_sp: this.editLegacySP,
          api: this.editAPIURL,
          comments: this.editCommentsTestCases,
          user_id: parseInt(this.userId),
        };
        this.axios
          .post("/co/rlp_site_map_upsert", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.closeDialog();
              this.getMenuDetails();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
  },
  components: {
    breadcrumbComp,
  },
};
